import type { JSX, ReactNode } from 'react';

/**
 * Cadre des écrans hors AppShell (connexion, accès refusé) : fond `background`,
 * contenu centré, logo selon le thème au-dessus de la carte.
 */
export function AuthScreen({ children }: { children: ReactNode }): JSX.Element {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4 text-foreground">
      <div className="flex items-center gap-2 text-heading">
        <img src="/icon_black.png" alt="" className="size-7 object-contain dark:hidden" />
        <img src="/icon_white.png" alt="" className="hidden size-7 object-contain dark:block" />
        <span>Voxler Router</span>
      </div>
      <div className="w-full max-w-[380px]">{children}</div>
    </main>
  );
}
